import { Button, Modal } from '@gravity-ui/uikit';

import styles from './styles.module.scss';

interface DocumentModalProps {
	open: boolean;
	onClose: () => void;
	pdfSrc?: string;
}

export const DocumentModal = ({ open, onClose, pdfSrc }: DocumentModalProps) => {
	return (
		<Modal open={open} onClose={onClose} className={styles.modal}>
			<div className={styles.modal__content}>
				<iframe src={pdfSrc} />
			</div>
			<Button onClick={onClose} className={styles.modal__btn} size="l">
				Закрыть
			</Button>
		</Modal>
	);
};
